import { Controller } from "@hotwired/stimulus"
import { useIntersection } from 'stimulus-use'
import { Alert } from "bootstrap"

export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 5000 }
  }

  connect() {
    useIntersection(this)
  }

  appear(entry, observer) {
    var alertNode = document.querySelector(".alert")
    if (alertNode) {
      var alert = Alert.getOrCreateInstance(alertNode)
      setTimeout(
        () => {
          if (alert && alert._element) {
            alert.close()
          }
        },
        this.dismissAfterValue
      )
    }
  }
}
